import React, { Component, useEffect, useState } from 'react';
import Scheduler, { SchedulerData, ViewTypes } from 'flagstone-scheduler';
import 'flagstone-scheduler/lib/css/style.css'
import { makeStyles, withStyles } from "@material-ui/core/styles";
import withDragDropContext from '../../../Helpers/WithDndContext';
import { setSchedularData } from "../../../Helpers/planningsHelper";
import EditCreateOrderDrawer from "../../Planning/EditCreateOrderDrawer";
import FlagstoneTheme from '../../../Config/flagstoneTheme';
import RestrictionsOverviewDrawer from '../../Planning/Restrictions/RestrictionsOverviewDrawer';
import CreateEditRestrictionDrawer from '../../Planning/Restrictions/CreateEditRestrictionDrawer'
import DateFnsUtils from '@date-io/date-fns';
import Popover from '@material-ui/core/Popover';
import MoreVertIcon from '@material-ui/icons/MoreVert';
import {
    DatePicker,

    MuiPickersUtilsProvider,
} from '@material-ui/pickers';
import { IconButton, InputAdornment, TextField } from "@material-ui/core";
import WorkingHoursOverviewDrawer from '../../Planning/WorkingHours/WorkingHoursOverviewDrawer';
import EditWorkingHoursDrawer from '../../Planning/WorkingHours/EditWorkingHoursDrawer';
import ClosingDaysOverviewDrawer from '../../Planning/ClosingDays/ClosingDaysOverviewDrawer';
import CreateClosingDayDrawer from '../../Planning/ClosingDays/CreateClosingDayDrawer';
import { fromNewDateFormatToDDMMYYYY, fromNewDateFormatToYYYYMMDDHHmmss, toDateFormatWithoutT } from '../../../Helpers/dateHelper'
import AlertDialog from '../../Shared/Dialogs/AlertDialog';
import DeleteDialog from '../../Shared/Dialogs/DeleteDialog';
import { dataService } from '../../../Services/data.service'
import { toast } from 'react-toastify';
import { productionLine, day, week, month } from '../../../Config/constants';
import { connect } from 'react-redux';
import { ContactlessOutlined, ControlPointSharp, LocalConvenienceStoreOutlined, ModeCommentOutlined, SignalCellularNull } from '@material-ui/icons';
import { getEventsFromProductionOrders } from '../../../Helpers/planningsHelper';
import { setCreateEditDrawerOpen, setPlanningDate } from '../../../Reducers/actions';
import { getDate } from 'date-fns';
import { productionOrderStates as states } from '../../../Config/productionOrderStates';
import Alert2Dialog from '../../Shared/Dialogs/Alert2Dialog';
import { dateTimePickerDefaultProps } from '@material-ui/pickers/constants/prop-types';

export const PlanningsPage = (props) => {

    const classes = useStyles();

    const [viewModel, setViewModel] = useState(null)
    const [productionOrders, setProductionOrders] = useState([])
    const [workstations, setWorkstations] = useState([])
    const [editCreateOrderDrawerOpen, setEditCreateOrderDrawerOpen] = useState(false)
    const [restrictionsOverviewDrawerOpen, setRestrictionsOverviewDrawerOpen] = useState(false)
    const [createEditRestrictionDrawerOpen, setCreateEditRestrictionDrawerOpen] = useState(false)
    const [workingHoursOverviewDrawerOpen, setWorkingHoursOverviewDrawerOpen] = useState(false)
    const [closingDaysOverviewDrawerOpen, setClosingDaysOverviewDrawerOpen] = useState(false)
    const [createClosingDayDrawerOpen, setCreateClosingDayDrawerOpen] = useState(false)
    const [editWorkingHoursDrawerOpen, setEditWorkingHoursDrawerOpen] = useState(false)
    const [orderToEdit, setOrderToEdit] = useState(null)
    const [orderIdToDelete, setOrderIdToDelete] = useState(null)
    const [restrictionToEdit, setRestrictionToEdit] = useState(null)
    const [start, setStart] = useState(null)
    const [end, setEnd] = useState(null)
    const [productionOrderLine, setProductionOrderLine] = useState(null)
    const [restrictionAlertDialogOpen, setRestrictionAlertDialogOpen] = useState(false)
    const [conflictAlertDialogµopen, setConflictAlertDialogOpen] = useState(false)
    const [splittingAlertDialogOpen, setSplittingAlertDialogOpen] = useState(false)
    const [alertButton1Text, setAlertButton1Text] = useState(null)
    const [alertButton2Text, setAlertButton2Text] = useState(null)
    const [deleteOrderDialogOpen, setDeleteOrderDialogOpen] = useState(false)
    const [dialogTitle, setDialogTitle] = useState(null)
    const [dialogContext, setDialogContext] = useState(null)
    const [extraAlertInfo, setExtraAlertInfo] = useState(null)
    const [date, setDate] = useState(null)
    const [anchorEl, setAnchorEl] = useState(null)
    const [refresh, setRefresh] = useState(false)
    const [searchString, setSearchString] = useState(null)
    const [rescheduleObject, setRescheduleObject] = useState(null)
    const [orderToSplit, setOrderToSplit] = useState(null)

    useEffect(() => {

        dataService.getPlanningData().then(data => {
            if (new Date(props.planning.date).getDate() !== new Date().getDate()) {
                props.actions.setPlanningDate(new Date())
            }

            if (date === null) {
                setDate(new Date())
            }

            let schedularData = setSchedularData(data.machines, data.productionOrders, props.actions, props.planningViewType, props)

            if (viewModel === null) {
                setViewModel(schedularData)
            }
            if (JSON.stringify(productionOrders) !== JSON.stringify(data.productionOrders)) {
                setProductionOrders(data.productionOrders)
            }
            if (JSON.stringify(workstations) !== JSON.stringify(data.machines)) {
                setWorkstations(data.machines)

                if (props.planning.createEditDrawerOpen) {
                    props.actions.setCreateEditDrawerOpen(false)
                    setStart(fromNewDateFormatToYYYYMMDDHHmmss(new Date()))
                    setEnd(fromNewDateFormatToYYYYMMDDHHmmss(new Date()))
                    setProductionOrderLine(1)
                    setOrderToEdit(null)
                    setEditCreateOrderDrawerOpen(true)
                }
            }

        }).catch((error) => { toast.error(error, { position: toast.POSITION.TOP_CENTER }) })
    }, [refresh])

    const prevClick = (schedulerData) => {
        schedulerData.prev();
        schedulerData.setEvents(props.planning.data.events);
        setViewModel(schedulerData)
    }

    const nextClick = (schedulerData) => {
        schedulerData.next();
        schedulerData.setEvents(props.planning.data.events);
        setViewModel(schedulerData)
    }

    const onViewChange = (schedulerData, view) => {
        schedulerData.setViewType(view.viewType, view.showAgenda, view.isEventPerspective);
        setDate(date)
        schedulerData.setDate(date)
        schedulerData.setEvents(props.planning.data.events);
        setViewModel(schedulerData)
        setRefresh(!refresh)
    }

    const onSelectDate = (schedulerData, date) => {
        schedulerData.setDate(date);
        schedulerData.setEvents(props.planning.data.events);
        setViewModel(schedulerData)
    }

    const openDeleteOrderDialog = (schedularData, event) => {
        let ordernumber = productionOrders.find(x => x.id === event.id).reference
        setOrderIdToDelete(event.id)
        setDialogTitle("Delete this order?")
        setDialogContext("Are you sure deleting order '" + ordernumber + "'? ")
        setDeleteOrderDialogOpen(true)
    }

    const deleteOrder = () => {

        var allProductionOrders = [...productionOrders]
        let originalOrder = allProductionOrders.find(x => x.id === orderIdToDelete)
        let index = allProductionOrders.findIndex(x => x.id === orderIdToDelete);
        allProductionOrders.splice(index, 1)
        setProductionOrders(allProductionOrders)

        // let nofificationMessage = "Order " + originalOrder.reference + " was  deleted on workstation " + originalOrder.machinePlannedCode + "."
        // dataService.saveNotification(Warning, nofificationMessage).then().catch((error) => { toast.error(error, { position: toast.POSITION.TOP_CENTER }) })


        dataService.deleteProductionOrderById(orderIdToDelete).then(

            setTimeout(() => {
                updatePlanningsPage(allProductionOrders)
            }, 2000)

        ).catch((error) => { toast.error(error, { position: toast.POSITION.TOP_CENTER }) })

        setDeleteOrderDialogOpen(false)
    }

    const saveOrder = (orderId, state, start, end, orderChangeAllowedDenied) => {

        var allProductionOrders = [...productionOrders]
        var originalOrder = allProductionOrders.find(x => x.id === orderId)
        let machineId = originalOrder.machineIdPlanned
        // if (isMaintenanceOrder(originalOrder)) {

        //     machineId = workstations.find(x => x.code === String(getMachineToMaintain(originalOrder))).id
        // }

        setRescheduleObject({ start: start, end: end, workstation: originalOrder.machineIdPlanned, orderId: orderId, create: false, update: true, state: state })

        if (orderChangeAllowed(new Date(start), new Date(end), machineId, true, originalOrder.id, false, orderChangeAllowedDenied)) {
            if (state !== originalOrder.productionOrderStatus) {
                if (state === states.RUNNING) {

                    // if (isFamilyOrder(originalOrder)) {
                    //     let parentOrderId = parseInt(JSON.parse(originalOrder.metaData).find(x => x.MetaDataType === 2).MetaData[0].DependentOrderId)
                    //     if (parentOrderId) {
                    //         if (allProductionOrders.find(x => x.id === parentOrderId).productionOrderStatus !== states.DONE) {
                    //             setDialogTitle("Start Alert")
                    //             setDialogContext("Order " + originalOrder.reference + " can't be started because order " +
                    //                 allProductionOrders.find(x => x.id === parentOrderId).reference + " must be finished first.")
                    //             setRestrictionAlertDialogOpen(true)
                    //             return
                    //         }
                    //     }
                    // }

                    dataService.startProductionOrder(orderId, originalOrder.machineIdPlanned).then().catch((error) => { toast.error(error, { position: toast.POSITION.TOP_CENTER }) })
                }
                if (state === states.PAUSED) {

                    dataService.pauseProductionOrder(orderId).then().catch((error) => { toast.error(error, { position: toast.POSITION.TOP_CENTER }) })
                }
                if (state === states.STOPPED) {
                    dataService.stopProductionOrder(orderId).then().catch((error) => { toast.error(error, { position: toast.POSITION.TOP_CENTER }) })
                }

                originalOrder.productionOrderStatus = state
            }



            if (originalOrder.start !== start || originalOrder.end !== end) {
                updateStartAndEndTime(originalOrder, allProductionOrders, start, end)
            }
            else {
                updatePlanningsPage(allProductionOrders)
            }
        }
    }

    const updatePlanningsPage = (updatedOrders) => {
        viewModel.setEvents(getEventsFromProductionOrders(updatedOrders, workstations, searchString, props))
        setViewModel(viewModel)
        setRefresh(!refresh);
    }

    const updateStartAndEndTime = (originalOrder, orders, start, end) => {

        start = new Date(new Date(start).setHours(new Date(start).getHours() + 2))
        end = new Date(new Date(end).setHours(new Date(end).getHours() + 2))

        originalOrder.startedOnPlanned = start
        originalOrder.finishedOnPlanned = end

        dataService.updateProductionOrder(originalOrder).then(
            setTimeout(() => {

                start = new Date(new Date(start).setHours(new Date(start).getHours() - 2))
                end = new Date(new Date(end).setHours(new Date(end).getHours() - 2))
                originalOrder.startedOnPlanned = start
                originalOrder.finishedOnPlanned = end
                updatePlanningsPage(orders)
            }, 1000)
        ).catch((error) => { toast.error(error, { position: toast.POSITION.TOP_CENTER }) })
    }

    const createOrder = (maintenance, machineId, ordernumber, article, pieces, salesorder, client, orderChangeAllowedDenied) => {

        openEditCreateOrderDrawer(false)
        let machineCodeToMaintain = ""
        if (maintenance) {
            machineCodeToMaintain = workstations.find(x => x.id === machineId).code
        }

        setRescheduleObject({
            start: start, end: end, workstation: machineId, orderId: null, create: true, update: false, maintenance: maintenance, machineCodeToMaintain: machineCodeToMaintain, ordernumber: ordernumber,
            article: article, pieces: pieces, salesOrder: salesorder, client: client
        })

        if (orderChangeAllowed(new Date(start), new Date(end), machineId, true, null, false, orderChangeAllowedDenied)) {

            dataService.createProductionOrder(maintenance, machineId, machineCodeToMaintain, ordernumber, article, pieces, salesorder, client, start, end).then(
                newOrder => {
                    setDate(start)
                    let allProductionOrders = [...productionOrders]
                    allProductionOrders.push(newOrder)
                    setProductionOrders(allProductionOrders)
                    updatePlanningsPage(allProductionOrders)
                }
            ).catch((error) => { toast.error(error, { position: toast.POSITION.TOP_CENTER }) })
        }
    }

    const editOrder = (schedulerData, event) => {
        setOrderToEdit(productionOrders.find(x => x.id === event.id))
        openEditCreateOrderDrawer(true)
    }

    const newEvent = (schedulerData, slotId, slotName, start, end, type, item) => {

        if (orderChangeAllowed(start, end, slotId, false, null, true)) {
            setStart(start)
            setEnd(end)
            setProductionOrderLine(slotId)
            setOrderToEdit(null)
            openEditCreateOrderDrawer(true)
        }
    }

    const addOrderOnPlanningsPage = () => {
        setStart(fromNewDateFormatToYYYYMMDDHHmmss(new Date()))
        setEnd(fromNewDateFormatToYYYYMMDDHHmmss(new Date()))
        setProductionOrderLine(1)
        setOrderToEdit(null)
        setEditCreateOrderDrawerOpen(true)
    }

    const updateEventStart = (schedulerData, event, newStart) => {
        var originalOrder = productionOrders.find(x => x.id === event.id)
        if (orderChangeAllowed(newStart, originalOrder.finishedOnPlanned, event.resourceId, false, event.id)) {
            moveOrder(event.id, event.resourceId, newStart, originalOrder.finishedOnPlanned)
        }
    }

    const updateEventEnd = (schedulerData, event, newEnd) => {
        var originalOrder = productionOrders.find(x => x.id === event.id)
        if (orderChangeAllowed(originalOrder.startedOnPlanned, newEnd, event.resourceId, false, event.id)) {
            moveOrder(event.id, event.resourceId, originalOrder.startedOnPlanned, newEnd)
        }
    }

    const moveEvent = (schedulerData, event, slotId, slotName, start, end) => {
        if (orderChangeAllowed(start, end, slotId, false, event.id)) {
            moveOrder(event.id, slotId, start, end)
        }
    }

    const moveOrder = (orderId, machineId, start, end, familyCheckDenied) => {
        var originalOrder = productionOrders.find(x => x.id === orderId)
        var allProductionOrders = [...productionOrders]
        let machineCode = workstations.find(x => x.id === machineId).code

        let metaData = JSON.parse(originalOrder.metaData)
        if (metaData.find(x => x.MetaDataType === 1).MetaData[0].Maintenance) {

            metaData.find(x => x.MetaDataType === 1).MetaData[0].MachineToMaintain = machineCode
            metaData.find(x => x.MetaDataType === 1).MetaData[0].MaintenanceDescription = "Maintenance on line " + machineCode
            originalOrder.metaData = JSON.stringify(metaData)
        }
        else {
            if (originalOrder.productionOrderStatus === states.PLANNED) {
                originalOrder.machineIdPlanned = machineId
            }
            else {
                originalOrder.machineIdPlanned = machineId
                originalOrder.machineId = machineId
            }
        }

        // if (isFamilyOrder(originalOrder) && !familyCheckDenied) {

        //     if (JSON.parse(originalOrder.metaData).find(x => x.MetaDataType === 2).MetaData[0].MachineId) {
        //         if (JSON.parse(originalOrder.metaData).find(x => x.MetaDataType === 2).MetaData[0].MachineId !== String(machineId)) {
        //             setDialogTitle("Planning Alert")
        //             let machineToFollow = workstations.find(x => String(x.id) === JSON.parse(originalOrder.metaData).find(x => x.MetaDataType === 2).MetaData[0].MachineId).code
        //             setDialogContext("Order " + originalOrder.reference + " can't be planned on workstation " + machineCode + ". Please move this order to workstation " + machineToFollow + ".")
        //             setAlertButton2Text("Proceed with workstation " + machineCode)
        //             setAlertButton1Text("Move to workstation " + machineToFollow)
        //             setConflictAlertDialogOpen(true)
        //             return
        //         }
        //     }
        //     let familyId = JSON.parse(originalOrder.metaData).find(x => x.MetaDataType === 2).MetaData[0].FamilyId
        //     let sequence = JSON.parse(originalOrder.metaData).find(x => x.MetaDataType === 2).MetaData[0].Sequence

        //     let allFamilyOrders = allProductionOrders.filter(x => JSON.parse(x.metaData).some(x => x.MetaDataType === 2))
        //     let orderFromSameFamilyPreviousSequence = allFamilyOrders.filter(x => JSON.parse(x.metaData).find(x => x.MetaDataType === 2).MetaData[0].FamilyId === familyId && (sequence - JSON.parse(x.metaData).find(x => x.MetaDataType === 2).MetaData[0].Sequence === 1))
        //     if (orderFromSameFamilyPreviousSequence.length > 0) {
        //         if (new Date(orderFromSameFamilyPreviousSequence[0].finishedOnPlanned) > new Date(start)) {
        //             setDialogTitle("Planning Alert")
        //             setDialogContext("Order " + originalOrder.reference + " can't be planned before order " + orderFromSameFamilyPreviousSequence[0].reference + " scheduled at " + toDateFormatWithoutT(orderFromSameFamilyPreviousSequence[0].startedOnPlanned) + " on workstation " + orderFromSameFamilyPreviousSequence[0].machinePlannedCode + ". Please choose a time slot after the order " + orderFromSameFamilyPreviousSequence[0].reference)
        //             setRestrictionAlertDialogOpen(true)
        //             return
        //         }
        //     }
        // }

        // let nofificationMessage = "Order " + originalOrder.reference + "  moved to workstation " + machineCode + "  from " + start + "  to " + end + "."
        // dataService.saveNotification(Info, nofificationMessage).then().catch((error) => { toast.error(error, { position: toast.POSITION.TOP_CENTER }) })

        updateStartAndEndTime(originalOrder, allProductionOrders, start, end)
    }

    const splitOrder = () => {

        saveOrder(orderToSplit.id, states.STOPPED, orderToSplit.startedOnPlanned, new Date(), true)
        setStart(fromNewDateFormatToYYYYMMDDHHmmss(new Date()))
        setEnd(fromNewDateFormatToYYYYMMDDHHmmss(new Date()))
        setProductionOrderLine(1)
        setOrderToEdit(null)
        setEditCreateOrderDrawerOpen(true)
        setSplittingAlertDialogOpen(false)
    }

    const openSplitOrderAlert = (order) => {
        setAlertButton1Text("Cancel splitting order remains PAUSED")
        setAlertButton2Text("Confirm splitting create new order")
        setExtraAlertInfo(null)
        setDialogTitle("Warning on splitting orders!")
        setDialogContext("You are about to split order " + order.reference + " on line " + order.machinePlannedCode)
        setSplittingAlertDialogOpen(true)
        setEditCreateOrderDrawerOpen(false)
        setOrderToSplit(order)
    }

    const onScrollRight = (schedulerData, schedulerContent, maxScrollLeft) => {
        if (schedulerData.ViewTypes === ViewTypes.Day) {
            schedulerData.next();
            schedulerData.setEvents(props.planning.data.events);
            setViewModel(schedulerData)
            schedulerContent.scrollLeft = maxScrollLeft - 10;
        }
    }

    const onScrollLeft = (schedulerData, schedulerContent, maxScrollLeft) => {
        if (schedulerData.ViewTypes === ViewTypes.Day) {
            schedulerData.prev();
            schedulerData.setEvents(props.planning.data.events);
            setViewModel(schedulerData)
            schedulerContent.scrollLeft = 10;
        }
    }

    const onScrollTop = (schedulerData, schedulerContent, maxScrollTop) => {
        console.log('onScrollTop');
    }

    const onScrollBottom = (schedulerData, schedulerContent, maxScrollTop) => {
        console.log('onScrollBottom');
    }

    const toggleExpandFunc = (schedulerData, slotId) => {
        schedulerData.toggleExpandStatus(slotId);
        setViewModel(schedulerData)
    }

    const openEditCreateOrderDrawer = (open) => {
        setEditCreateOrderDrawerOpen(open)
    }

    const openRestrictionsOverviewDrawer = (open) => {
        setRestrictionsOverviewDrawerOpen(open)
        setAnchorEl(null)
    }

    const openClosingDaysOverviewDrawer = (open) => {
        setClosingDaysOverviewDrawerOpen(open)
        setAnchorEl(null)
    }

    const openWorkingHoursOverviewDrawer = (open) => {
        setWorkingHoursOverviewDrawerOpen(open)
        setAnchorEl(null)
    }

    const openCreateEditRestrictionDrawer = (open, id) => {
        setCreateEditRestrictionDrawerOpen(open)

        if (id === null || id === undefined) {
            setRestrictionToEdit(null)
        }
        else {
            setRestrictionToEdit(JSON.parse(JSON.stringify(props.workstation.restrictions.find(x => x.id === id))))
        }
    }

    const openCreateClosingDayDrawer = (open) => {
        setCreateClosingDayDrawerOpen(open)
    }

    const openEditWorkingHoursDrawer = (open) => {
        setEditWorkingHoursDrawerOpen(open)
    }

    const closeDialog = () => {
        setRestrictionAlertDialogOpen(false)
        setDeleteOrderDialogOpen(false)
        setConflictAlertDialogOpen(false)
        setSplittingAlertDialogOpen(false)
    }

    const orderChangeAllowed = (start, end, workstation, newOrder, orderId, newEvent, orderChangeAllowedDenied) => {

        if (!newOrder) {
            setRescheduleObject({ start: start, end: end, workstation: workstation, orderId: orderId, create: false, update: false })
        }

        if ((viewModel.viewType === day || newOrder) && !orderChangeAllowedDenied) {
            if (!checkIfOrderDuringWorkingHours(start, end, workstation, null)) {
                return false;
            }

            if (!checkRestrictionOrderOverlapping(start, end, workstation,)) {
                return false;
            }

            if (!newEvent) {
                if (!checkOrderOverlapping(start, end, workstation, orderId)) {
                    return false;
                }
            }
        }

        return true;
    }

    const checkOrderOverlapping = (start, end, workstation, orderId) => {


        let originalOrder = productionOrders.find(x => x.id === orderId)
        let ordersOnSameLine = getOrdersOnSameLine(workstation, orderId)
        let machineCode = workstations.find(x => x.id === workstation).code

        var i;
        for (i = 0; i < ordersOnSameLine.length; i++) {

            let startOrder = new Date(start)
            let endOrder = new Date(end)
            let startOrderOnSameLine = new Date(ordersOnSameLine[i].startedOnPlanned)
            let endOrderOnSameLine = new Date(ordersOnSameLine[i].finishedOnPlanned)

            if ((startOrder >= startOrderOnSameLine && endOrder <= endOrderOnSameLine) || (startOrder <= startOrderOnSameLine && endOrder > startOrderOnSameLine)
                || (startOrder < endOrderOnSameLine && endOrder >= endOrderOnSameLine) || (startOrder <= startOrderOnSameLine && endOrder >= endOrderOnSameLine)) {

                    let notificationMessage = ""

                if (originalOrder){
                    notificationMessage = "Order " + originalOrder.reference + " was in conflict with order " + ordersOnSameLine[i].reference + " on workstation " + ordersOnSameLine[i].machinePlannedCode + "."

                }
                else{
                    notificationMessage = "New order was in conflict with order " + ordersOnSameLine[i].reference + " on workstation " + ordersOnSameLine[i].machinePlannedCode + "."

                }
                dataService.saveNotification(Error, notificationMessage).then().catch((error) => { toast.error(error, { position: toast.POSITION.TOP_CENTER }) })


                setAlertButton1Text("Choose another time or workstation")
                setAlertButton2Text("Enter rush order and reschedule planned orders")
                setExtraAlertInfo("What do you want to do?")
                setDialogTitle("Conflict Alert")
                setDialogContext("There is already a task scheduled between " + start + " and " + end + " on Workstation " + machineCode)
                setConflictAlertDialogOpen(true)
                return false
            }
        }

        return true
    }

    const checkRestrictionOrderOverlapping = (start, end, workstation, restrictions, orders) => {
        var y;
        if (orders) {
            for (y = 0; y < orders.length; y++) {
                //when creating restriction           
                if (checkRestrictionsforOrder(orders[y].startedOnPlanned, orders[y].finishedOnPlanned, orders[y].machineIdPlanned, restrictions, true, false)) {
                    return false
                }
            }

            return true;
        }
        else {
            //when editing, creating orders
            return checkRestrictionsforOrder(start, end, workstation, props.workstation.restrictions, false, true)
        }
    }

    const checkRestrictionsforOrder = (start, end, workstation, restrictions, createEditRestriction, createNewOrder) => {
        var i;
        let startOrder = new Date(start)
        let endOrder = new Date(end)
        for (i = 0; i < restrictions.length; i++) {

            let startRestriction = new Date(restrictions[i].start)
            let endRestriction = new Date(restrictions[i].end)
            let restrictionWorkstation = restrictions[i].workstation

            //Check closing day overlap with orders
            if (restrictionWorkstation === 0
                && startOrder.getDate() === startRestriction.getDate()
                && startOrder.getMonth() === startRestriction.getMonth()
                && startOrder.getFullYear() === startRestriction.getFullYear()) {
                setDialogTitle("Restriction Alert")
                if (createNewOrder) {
                    setDialogContext("Impossible to create order on closing day " + fromNewDateFormatToDDMMYYYY(restrictions[i].start) + ", please reschedule the order or closing day!")
                }
                else {
                    setDialogContext("Closing day overlap with planned order on production line " + workstations.find(x => x.id === workstation).code + " on " + fromNewDateFormatToDDMMYYYY(restrictions[i].start) + ", please reschedule the planned order or closing day!")
                }
                setRestrictionAlertDialogOpen(true)
                return false;
            }

            if ((startOrder >= startRestriction && startOrder < endRestriction && restrictionWorkstation === workstation)
                || (endOrder > startRestriction && endOrder <= endRestriction && restrictionWorkstation === workstation)
                || (startOrder <= startRestriction && endOrder >= endRestriction && restrictionWorkstation === workstation)) {
                setDialogTitle("Restriction Alert")
                let reason = ""
                if (restrictions[i].type === 1) {
                    reason = "Maintenance on production line " + workstations.find(x => x.id === workstation).code
                }
                if (restrictions[i].type === 2) {
                    reason = "Machine broken on production line " + workstations.find(x => x.id === workstation).code
                }
                if (restrictions[i].type === 3) {
                    reason = "Material deficit on production line " + workstations.find(x => x.id === workstation).code
                }

                if (createEditRestriction) {
                    reason = "Restriction overlap with order on production line " + workstations.find(x => x.id === workstation).code + " between " + restrictions[i].start + " and " + restrictions[i].end + ", please reschedule the order or restriction!"
                }
                else {
                    reason += " between " + restrictions[i].start + " and " + restrictions[i].end
                }
                setDialogContext(reason)
                setRestrictionAlertDialogOpen(true)

                return false;
            }
        }

        return true;
    }

    const checkIfOrderDuringWorkingHours = (start, end, workstation, changedWorkingHours) => {

        let startOrder = new Date(start)
        let endOrder = new Date(end)
        let dayOrder = endOrder.getDay()

        let workingHours = []
        if (changedWorkingHours) {
            workingHours = changedWorkingHours.filter(x => x.day === dayOrder && x.workstation === workstation)
        }
        else {
            workingHours = props.workstation.workingHours.filter(x => x.day === dayOrder && x.workstation === workstation)
        }

        let startArray = workingHours[0].start.split(':')
        let endArray = workingHours[0].end.split(':')
        let startHour = parseInt(startArray[0])

        let startMin = parseInt(startArray[1])
        let endHour = parseInt(endArray[0])

        let endMin = parseInt(endArray[1])

        let endOrderHour = endOrder.getHours()
        if (endOrderHour === 0) {
            endOrderHour = 24
        }

        if ((startOrder.getHours() > startHour || (startOrder.getHours() === startHour && startOrder.getMinutes() >= startMin))
            && (endOrderHour < endHour || (endOrder.getHours() === endHour && endOrder.getMinutes() <= endMin))) {

            return true;
        }
        else {
            if (changedWorkingHours) {
                setDialogTitle("Shift Alert")
                setDialogContext("There are planned orders between " + start + " and " + end + " on production line " + workstations.find(x => x.id === workstation).code + ", please reschedule the orders or the shift")
                setRestrictionAlertDialogOpen(true)
            }
            else {
                setDialogTitle("Shift Alert")
                setDialogContext("There is none-working time scheduled between " + start + " and " + end + " on production line " + workstations.find(x => x.id === workstation).code)
                setRestrictionAlertDialogOpen(true)
            }

            return false;
        }
    }

    const handleClose = () => {
        setAnchorEl(null)
    };

    const openPopover = (event) => {
        setAnchorEl(event.currentTarget)
    };

    const dateChanged = (schedularData, date) => {
        setDate(date)
        schedularData.setDate(date)
        schedularData.setEvents(props.planning.data.events);
        setViewModel(schedularData)
    }

    const searchOrder = (event) => {

        setSearchString(event.target.value)
        let string = event.target.value
        if (string !== "") {

            let startDate = ""
            var firstMatch = productionOrders.find(x => x.reference.includes(string))
            if (firstMatch) {
                startDate = firstMatch.startedOnPlanned
            }
            else {
                viewModel.setEvents(getEventsFromProductionOrders(productionOrders, workstations, "", props))
                setViewModel(viewModel)
                setRefresh(!refresh)
                return
            }

            setTimeout(() => {
                setDate(startDate)
                viewModel.setDate(startDate)
                viewModel.setEvents(getEventsFromProductionOrders(productionOrders, workstations, string, props))
                setViewModel(viewModel)
                setRefresh(!refresh)

            }, 1000)
        }
        else {
            viewModel.setEvents(getEventsFromProductionOrders(productionOrders, workstations, "", props))
            setViewModel(viewModel)
            setRefresh(!refresh)
        }
    }

    const rescheduleOrders = () => {

        moveOverlappingOrders(rescheduleObject.start, rescheduleObject.end, rescheduleObject.workstation, rescheduleObject.orderId)
        if (rescheduleObject.create) {
            createOrder(rescheduleObject.maintenance, rescheduleObject.workstation, rescheduleObject.ordernumber, rescheduleObject.article, rescheduleObject.pieces, rescheduleObject.salesOrder, rescheduleObject.client, true)
        }
        else if (rescheduleObject.update) {
            saveOrder(rescheduleObject.orderId, rescheduleObject.state, rescheduleObject.start, rescheduleObject.end, true)
        }
        else {
            moveOrder(rescheduleObject.orderId, rescheduleObject.workstation, rescheduleObject.start, rescheduleObject.end, true)
        }


        setConflictAlertDialogOpen(false)
    }

    const getOrdersOnSameLine = (workstation, orderId) => {
        let machineCode = workstations.find(x => x.id === workstation).code
        let maintenanceOrdersOnSameLine = []
        var y;
        for (y = 0; y < productionOrders.length; y++) {
            if (String(JSON.parse(productionOrders[y].metaData).find(x => x.MetaDataType === 1).MetaData[0].MachineToMaintain) === machineCode) {
                maintenanceOrdersOnSameLine.push(productionOrders[y])
            }
        }

        let ordersOnSameLine = productionOrders.filter(x => x.machineIdPlanned === workstation).concat(maintenanceOrdersOnSameLine)
        if (orderId) {
            ordersOnSameLine = ordersOnSameLine.filter(x => x.id !== orderId)
        }

        return ordersOnSameLine
    }

    const moveOverlappingOrders = (start, end, workstation, orderId) => {

        let ordersOnSameLine = getOrdersOnSameLine(workstation, orderId)
        var i;
        for (i = 0; i < ordersOnSameLine.length; i++) {

            let startOrder = new Date(start)
            let endOrder = new Date(end)
            let startOrderOnSameLine = new Date(ordersOnSameLine[i].startedOnPlanned)
            let endOrderOnSameLine = new Date(ordersOnSameLine[i].finishedOnPlanned)

            if ((startOrder >= startOrderOnSameLine && endOrder <= endOrderOnSameLine) || (startOrder <= startOrderOnSameLine && endOrder > startOrderOnSameLine)
                || (startOrder < endOrderOnSameLine && endOrder >= endOrderOnSameLine) || (startOrder <= startOrderOnSameLine && endOrder >= endOrderOnSameLine)) {

                let minutesToMoveAhead = (endOrder - startOrderOnSameLine) / 60000
                console.log(minutesToMoveAhead)
                startOrderOnSameLine.setMinutes(startOrderOnSameLine.getMinutes() + minutesToMoveAhead);
                endOrderOnSameLine.setMinutes(endOrderOnSameLine.getMinutes() + minutesToMoveAhead);
                let machineId = ordersOnSameLine[i].machineIdPlanned
                if (JSON.parse(ordersOnSameLine[i].metaData).find(x => x.MetaDataType === 1).MetaData[0].Maintenance) {
                    machineId = workstations.find(x => x.code === String(JSON.parse(ordersOnSameLine[i].metaData).find(x => x.MetaDataType === 1).MetaData[0].MachineToMaintain)).id
                }

                moveOrder(ordersOnSameLine[i].id, machineId, startOrderOnSameLine, endOrderOnSameLine)
                moveFutureOrdersSameLineAheadInTime(ordersOnSameLine.filter(x => new Date(x.startedOnPlanned) >= endOrder && x.id !== ordersOnSameLine[i].id), endOrderOnSameLine)

                return;
            }
        }
    }

    const moveFutureOrdersSameLineAheadInTime = (orders, endTimeOfFirstMovedOrder) => {

        var i;
        for (i = 0; i < orders.length; i++) {
            let startOrder = new Date(orders[i].startedOnPlanned)
            let endOrder = new Date(orders[i].finishedOnPlanned)
            if (startOrder <= endTimeOfFirstMovedOrder) {
                let minutesToMoveAhead = (endTimeOfFirstMovedOrder - new Date(orders[i].startedOnPlanned)) / 60000
                startOrder.setMinutes(startOrder.getMinutes() + minutesToMoveAhead);
                endOrder.setMinutes(endOrder.getMinutes() + minutesToMoveAhead);

                let machineId = orders[i].machineIdPlanned
                if (JSON.parse(orders[i].metaData).find(x => x.MetaDataType === 1).MetaData[0].Maintenance) {
                    machineId = workstations.find(x => x.code === String(JSON.parse(orders[i].metaData).find(x => x.MetaDataType === 1).MetaData[0].MachineToMaintain)).id
                }

                moveOrder(orders[i].id, machineId, startOrder, endOrder)
                moveFutureOrdersSameLineAheadInTime(orders.filter(x => x.id !== orders[i].id), endOrder)
            }
        }
    }


    let open = Boolean(anchorEl);
    let id = open ? 'simple-popover' : undefined;

    return (
        <div className={classes.background}>
            {viewModel ? <React.Fragment>
                <div className={classes.spacer80}>
                    <div className={classes.planningTitle}>
                        Planning
                     </div>
                    <div className={classes.options}><button className={classes.optionsButton} onClick={openPopover}><MoreVertIcon style={{ height: "30px", width: "30px", fill: FlagstoneTheme.palette.primary.main }}></MoreVertIcon></button></div>
                    <button className={classes.rushButton} onClick={() => addOrderOnPlanningsPage()}>
                        <div className={classes.refreshText}>{"+ ADD ORDER"}</div>
                    </button>
                    <div className={classes.searchContainer}>
                        <div className={classes.searchTitle}>
                            Search
                            </div>
                        <TextField
                            className={classes.search}
                            id="input-with-icon-textfield"
                            variant="outlined"
                            size="small"
                            onChange={(e) => searchOrder(e)}
                            InputProps={{
                                endAdornment: (
                                    <InputAdornment position="end">
                                        <img className={classes.eye} src={process.env.PUBLIC_URL + '/img/search.svg'} alt={""}></img>
                                    </InputAdornment>
                                ),
                            }}>
                        </TextField>
                    </div>
                    <div className={classes.dates}>
                        <div className={classes.date}>
                            <div className={classes.fromtill}>
                                Date
                            </div>
                            <div>
                                <MuiPickersUtilsProvider utils={DateFnsUtils}>
                                    <DatePicker className={classes.datePicker}
                                        autoOk
                                        variant="inline"
                                        inputVariant="outlined"
                                        format="dd-MM-yyyy"
                                        onChange={date => dateChanged(viewModel, date)}
                                        size='small'
                                        value={date}
                                        InputProps={{
                                            endAdornment: (
                                                <InputAdornment className={classes.inputAdornment} position="end">
                                                    <IconButton className={classes.iconButton}>
                                                        <img className={classes.calendar} alt="calendar" src={process.env.PUBLIC_URL + '/img/calendar.svg'}></img>
                                                    </IconButton>
                                                </InputAdornment>
                                            ),
                                        }}
                                    />
                                </MuiPickersUtilsProvider>
                            </div>
                        </div>
                    </div>
                </div>
                <Scheduler className={classes.scheduler} schedulerData={viewModel}
                    prevClick={prevClick}
                    nextClick={nextClick}
                    onSelectDate={onSelectDate}
                    onViewChange={onViewChange}
                    eventItemClick={editOrder}
                    viewEventClick={openDeleteOrderDialog}
                    viewEventText="DELETE"
                    viewEvent2Text="EDIT"
                    viewEvent2Click={editOrder}
                    updateEventStart={updateEventStart}
                    updateEventEnd={updateEventEnd}
                    moveEvent={moveEvent}
                    newEvent={newEvent}
                    onScrollLeft={onScrollLeft}
                    onScrollRight={onScrollRight}
                    onScrollTop={onScrollTop}
                    onScrollBottom={onScrollBottom}
                    toggleExpandFunc={toggleExpandFunc}
                />
                <EditCreateOrderDrawer splitOrder={openSplitOrderAlert} workstations={workstations} openDrawer={openEditCreateOrderDrawer} drawerOpen={editCreateOrderDrawerOpen} setStart={setStart} setEnd={setEnd} start={start} end={end} selectedWorkstation={productionOrderLine} productionOrder={orderToEdit} saveOrder={saveOrder} createOrder={createOrder} {...props}></EditCreateOrderDrawer>
                <EditWorkingHoursDrawer openDrawer={openEditWorkingHoursDrawer} drawerOpen={editWorkingHoursDrawerOpen} {...props} actions={props.actions} checkIfOrderDuringWorkingHours={checkIfOrderDuringWorkingHours}></EditWorkingHoursDrawer>
                <WorkingHoursOverviewDrawer openEditWorkingHoursDrawer={openEditWorkingHoursDrawer} openDrawer={openWorkingHoursOverviewDrawer} drawerOpen={workingHoursOverviewDrawerOpen} {...props} actions={props.actions}></WorkingHoursOverviewDrawer>
                <ClosingDaysOverviewDrawer openCreateClosingDayDrawer={openCreateClosingDayDrawer} openDrawer={openClosingDaysOverviewDrawer} drawerOpen={closingDaysOverviewDrawerOpen} {...props} actions={props.actions}></ClosingDaysOverviewDrawer>
                <CreateClosingDayDrawer openDrawer={openCreateClosingDayDrawer} drawerOpen={createClosingDayDrawerOpen} {...props} actions={props.actions} checkRestrictionOrderOverlapping={checkRestrictionOrderOverlapping}></CreateClosingDayDrawer>
                <RestrictionsOverviewDrawer openCreateEditRestrictionDrawer={openCreateEditRestrictionDrawer} openDrawer={openRestrictionsOverviewDrawer} drawerOpen={restrictionsOverviewDrawerOpen} {...props} actions={props.actions}></RestrictionsOverviewDrawer>
                <CreateEditRestrictionDrawer restriction={restrictionToEdit} openDrawer={openCreateEditRestrictionDrawer} drawerOpen={createEditRestrictionDrawerOpen} {...props} actions={props.actions} checkRestrictionOrderOverlapping={checkRestrictionOrderOverlapping}></CreateEditRestrictionDrawer>
                <Alert2Dialog dialogOpen={splittingAlertDialogOpen} extraAlertInfo={extraAlertInfo} action2={splitOrder} action={closeDialog} dialogTitle={dialogTitle} dialogContext={dialogContext} button1Text={alertButton1Text} button2Text={alertButton2Text}></Alert2Dialog>
                <Alert2Dialog dialogOpen={conflictAlertDialogµopen} extraAlertInfo={extraAlertInfo} action2={rescheduleOrders} action={closeDialog} dialogTitle={dialogTitle} dialogContext={dialogContext} button1Text={alertButton1Text} button2Text={alertButton2Text}></Alert2Dialog>
                <AlertDialog {...props} dialogOpen={restrictionAlertDialogOpen} action={closeDialog} dialogTitle={dialogTitle} dialogContext={dialogContext}></AlertDialog>
                <DeleteDialog {...props} dialogOpen={deleteOrderDialogOpen} action={deleteOrder} closeDialog={closeDialog} dialogTitle={dialogTitle} dialogContext={dialogContext}></DeleteDialog>
                <Popover
                    id={id}
                    open={open}
                    anchorEl={anchorEl}
                    onClose={handleClose}
                    anchorOrigin={{
                        vertical: 'bottom',
                        horizontal: 'center',
                    }}
                    transformOrigin={{
                        vertical: 'top',
                        horizontal: 'center',
                    }}
                >
                    <div className={classes.optionsMenu}>
                        <div className={classes.restrictionsOption}><button className={classes.optionsMenuItem} onClick={() => openRestrictionsOverviewDrawer(true)}>Workstation restrictions</button></div>
                        <div className={classes.workingHoursOption}><button className={classes.optionsMenuItem} onClick={() => openWorkingHoursOverviewDrawer(true)}>Working hours</button></div>
                        <div className={classes.closingDaysOption}><button className={classes.optionsMenuItem} onClick={() => openClosingDaysOverviewDrawer(true)}>Closing days</button></div>
                    </div>
                </Popover>
            </React.Fragment> : <React.Fragment></React.Fragment>}
        </div>
    )
}

const useStyles = makeStyles(() => ({
    spacer80: {
        height: '80px',
        color: "#000000",
        fontSize: "32px",
        fontFamily: "Lato, sans-serif",
        fontWeight: 'medium',
    },
    background: {
        height: '100vh',
        width: '100%',
        padding: "20px",
        boxSizing: "border-box",
        marginTop: "40px"
    },
    scheduler: {
        margin: "5px auto"
    },
    schedulerContainer: {

    },
    restrictions: {
        float: "right",
        marginBottom: "60px"
    },
    blockIcon: {
        color: FlagstoneTheme.palette.primary.main,
        width: "20px",
        height: "20px",
        float: "left"
    },
    restrictionsButton: {
        outline: "none",
        border: "none",
        cursor: "pointer",
        color: FlagstoneTheme.palette.primary.main,
        fontSize: "14px",
        fontFamily: "Lato, sans-serif",
        fontWeight: 'medium',
        width: "120px",
        marginBottom: "5px"

    },
    restrictionText: {
        paddingTop: "2px",
        marginLeft: "5px",
        float: "left"

    },
    planningTitle: {
        float: "left",
        width: "fit-content",
        position: "relative",
        top: "60px",
        paddingLeft: "0.8%"
    },
    fromtill: {
        display: 'block',
        color: '#020100',
        fontSize: "12px",
        fontFamily: "Lato, sans-serif",
        fontWeight: 'bold',
    },
    searchTitle: {
        color: '#020100',
        fontSize: "12px",
        fontFamily: "Lato, sans-serif",
        fontWeight: 'bold',
    },
    datePicker: {
        borderRadius: "6px",
        backgroundColor: "white",
        "& input": {
            fontSize: "14px !important",
            fontFamily: "Lato, sans-serif !important",
        },
        marginBottom: '10px',
        width: "90%"

    },
    date: {
        width: "100%",
        float: "left",
    },
    dates: {
        height: "50px",
        float: "right",
        paddingTop: "45px",
        position: "relative"
    },
    options: {
        width: "20px",
        float: "right",
        position: "relative",
        top: "55px",
        right: "5px"
    },
    optionsButton: {
        border: "none",
        outline: "none",
        cursor: "pointer"
    },
    optionsMenu: {
        width: "180px",
        height: "120px"

    },
    restrictionsOption: {
        width: "100%",
        height: "40px",
        paddingTop: "12px",
        paddingLeft: "10px",
        boxSizing: "border-box",
        borderBottom: "1px solid #DEDEDE"

    },
    workingHoursOption: {
        width: "100%",
        height: "40px",
        paddingTop: "12px",
        paddingLeft: "10px",
        boxSizing: "border-box",
        borderBottom: "1px solid #DEDEDE"

    },
    closingDaysOption: {
        width: "100%",
        height: "40px",
        paddingTop: "12px",
        paddingLeft: "10px",
        boxSizing: "border-box"
    },
    optionsMenuItem: {
        border: "none",
        outline: "none",
        cursor: "pointer",
        backgroundColor: "white",
        fontSize: "14px",
        fontFamily: "Lato, sans-serif",
        fontWeight: 'medium',
    },
    search: {
        backgroundColor: "white",
    },
    searchContainer: {
        float: "right",
        position: "relative",
        right: "500px",
        top: "45px"
    },
    rushButton: {
        width: "130px",
        height: "40px",
        border: "none",
        outline: "none",
        backgroundColor: FlagstoneTheme.palette.primary.main,
        borderRadius: "5px",
        marginTop: "15px",
        cursor: "pointer",
        zIndex: "999",
        position: "relative",
        right: "900px",
        float: "right",
        paddingLeft: "15px",
        paddingBottom: "5px",
        top: "44px"
    },
    refreshText: {
        fontSize: "14px",
        fontFamily: "Lato, sans-serif",
        color: "white",
        float: "left",
        paddingTop: "3px",
        cursor: "pointer"

    },
}));


function mapStateToProps(state) {
    return { planning: state.planning }
}

export default connect(mapStateToProps)(withDragDropContext(PlanningsPage))